import { useState } from "react"
import PropTypes from "prop-types"
import { Checkbox, FormControl, TextField, Typography } from "@mui/material"
import classNames from "classnames"
import { validName } from "../helpers"

export default function Item({ item, type, makeOnChange }) {
  const [touched, setTouched] = useState(false)

  const { id, name, checked, description, isInvalid } = item
  // We display errors only on active, touched elements, not invalid because they're fully disabled
  // and not unchecked because they are not being sent for creation
  const displayError = checked && !isInvalid && !validName(name) && touched

  return <div className={classNames("item", { error: isInvalid })}>
    <div>
      <Checkbox
        id={id}
        name={id}
        checked={checked}
        onChange={makeOnChange("checked")}
        disabled={isInvalid}
      />
      <FormControl variant="standard" className="id">
        <TextField variant="standard" id="id" name="id" label="Id" value={id} disabled />
      </FormControl>
      <FormControl
        variant="standard"
        className={classNames("name", { error: displayError })}
      >
        <TextField
          variant="standard"
          id="name"
          name="name"
          label="Name"
          value={name}
          onChange={makeOnChange("name")}
          disabled={isInvalid}
          error={displayError}
          helperText={displayError && "Invalid name"}
          onBlur={() => setTouched(true)}
          slotProps={{
            htmlInput: {
              maxLength: 50,
            },
          }}
        />
      </FormControl>
      <FormControl variant="standard" className="description">
        <TextField
          variant="standard"
          id="description"
          name="description"
          label="Description"
          multiline
          maxRows={4}
          value={description}
          onChange={makeOnChange("description")}
          disabled={isInvalid}
          slotProps={{
            htmlInput: {
              maxLength: 255,
            },
          }}
        />
      </FormControl>
    </div>
    {isInvalid && <Typography className="message" variant="subtitle2">This {type} category cannot be created because the id is invalid.</Typography>}
  </div>
}

Item.propTypes = {
  type: PropTypes.oneOf(["attribute", "tag"]).isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    description: PropTypes.string,
    isInvalid: PropTypes.bool.isRequired,
  }).isRequired,
  makeOnChange: PropTypes.func.isRequired,
}
